import PropTypes from 'prop-types';

const appType = PropTypes.shape({
  name: PropTypes.string.isRequired,
});

const appProperty = PropTypes.shape({
  name: PropTypes.string.isRequired,
});

const category = PropTypes.shape({
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
});

const demoItem = PropTypes.shape({
  description: PropTypes.string.isRequired,
  large_url: PropTypes.string.isRequired,
  wistia_video_id: PropTypes.string,
  display_weight: PropTypes.number,
});

const capability = PropTypes.shape({
  name: PropTypes.string.isRequired,
});

const capabilityGroup = PropTypes.shape({
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  description: PropTypes.string,
  capabilities: PropTypes.arrayOf(capability).isRequired,
});

const listing = PropTypes.shape({
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  short_description: PropTypes.string,
  description: PropTypes.string,
  categories: PropTypes.arrayOf(category).isRequired,
  number_of_connections: PropTypes.number,
  website_url: PropTypes.string,
  help_url: PropTypes.string,
  terms_of_service_url: PropTypes.string,
  logo_url: PropTypes.string,
  pricing_url: PropTypes.string,
  discount_url: PropTypes.string,
  discount_description: PropTypes.string,
  demo_items: PropTypes.arrayOf(demoItem),
  capability_groups: PropTypes.arrayOf(capabilityGroup),
  types: PropTypes.arrayOf(appType).isRequired,
  properties: PropTypes.arrayOf(appProperty).isRequired,
});

const categoryGroup = PropTypes.shape({
  name: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(category).isRequired,
});

export { listing, categoryGroup, demoItem, capabilityGroup };
